export default {
    mobileResulution:500,
    tabletResolution: 768
}